import React, { useState } from "react";
import useCountdown from "../../../hooks/useCountdown";
import OtpInput from "react-otp-input";
import { useTranslate } from "@tolgee/react";
import {
  Hero, Globe, Title, Subtitle, Fields, PrimaryBtn, BackBtn, ErrorText, TextLink, OtpWrapper, OtpBox, ResendSuccess, ResendTimer, TermsFooter
} from "../shared/AuthUI";

const PhoneOtpStep = ({
  phone,
  onBack,
  verifyPhoneOtp,
  resendPhoneOtp,
}) => {
  const { t } = useTranslate();
  const [otp, setOtp] = useState("");
  const [wrongCode, setWrongCode] = useState(false);
  const [resent, setResent] = useState(false);
  const [countdown, resetCountdown] = useCountdown(30);

  const handleVerify = (code) => {
    if ((code || otp).length !== 6) return;
    setWrongCode(false);
    verifyPhoneOtp(
      code || otp,
      () => {},
      () => { setOtp(""); setWrongCode(true); }
    );
  };


  const handleResend = () => {
    setOtp("");
    setWrongCode(false);
    setResent(false);
    resendPhoneOtp(() => { setResent(true); resetCountdown(); });
  };

  return (
    <>
      <BackBtn onClick={onBack}>{t("general.back")}</BackBtn>

      <Hero>
        <Globe>📱</Globe>
        <Title>{t("authentication.otp.phone_title")}</Title>
        <Subtitle>{t("authentication.otp.phone_subtitle", { phone })}</Subtitle>
      </Hero>

      <Fields>
        <OtpWrapper>
          <OtpInput
            containerStyle={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "8px" }}
            shouldAutoFocus
            value={otp}
            onChange={(val) => { setOtp(val); setWrongCode(false); if (val.length === 6) handleVerify(val); }}
            numInputs={6}
            renderSeparator={null}
            renderInput={(props) => <OtpBox {...props} error={wrongCode} />}
          />
        </OtpWrapper>

        {wrongCode && <ErrorText>{t("authentication.error.invalid_code")}</ErrorText>}
        {resent && <ResendSuccess>{t("authentication.otp.resend_success_sms")}</ResendSuccess>}

        <PrimaryBtn disabled={otp.length < 6} onClick={() => handleVerify(otp)}>
          {t("authentication.otp.verify_button")}
        </PrimaryBtn>

        {countdown > 0
          ? <ResendTimer>{t("authentication.otp.resend_timer", { countdown })}</ResendTimer>
          : <TextLink onClick={handleResend}>{t("authentication.otp.resend_link")}</TextLink>
        }
      </Fields>

      <TermsFooter />
    </>
  );
};

export default PhoneOtpStep;
